import { useEffect, useState } from "react";
import { Col, Container, Row, Nav, Button, Offcanvas, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Menu } from "antd";
import { 
    HomeOutlined, 
    InfoCircleOutlined, 
    PhoneOutlined, 
    BuildOutlined, // For Projects
    SafetyCertificateOutlined, // For Privacy
    FileProtectOutlined // For Disclaimer
} from '@ant-design/icons';
import logo from '../../assets/images/CPR_LOGO.png';
import logoTwo from '../../assets/images/CPR_LOGO_DARK.png';

const mobileMenuItems = [
    {
        key: 'home',
        icon: <HomeOutlined />,
        label: 'Home',
    },
    {
        key: 'cpr-park-heights',
        icon: <BuildOutlined />, // Building icon for project
        label: 'Park Heights',
    },
    {
        key: 'cpr-cosmos',
        icon: <BuildOutlined />, // Building icon for project
        label: 'Cosmos',
    },
    {
        key: 'cpr-mangala',
        icon: <BuildOutlined />, // Building icon for project
        label: 'Mangala',
    },
    {
        key: 'privacy-policy',
        icon: <SafetyCertificateOutlined />,
        label: 'Privacy Policy',
    },
    {
        key: 'disclaimer',
        icon: <FileProtectOutlined />,
        label: 'Disclaimer',
    },
];

const getLevelKeys = (items1) => {
    const key = {};
    const func = (items2, level = 1) => {
        items2.forEach(item => {
            if (item.key) key[item.key] = level;
            if (item.children) func(item.children, level + 1);
        });
    };
    func(items1);
    return key;
};

const levelKeys = getLevelKeys(mobileMenuItems);

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [currentPath, setCurrentPath] = useState(location.pathname);
    const [showSideNav, setShowSideNav] = useState(false);
    const [stateOpenKeys, setStateOpenKeys] = useState([]);
    const [scrolled, setScrolled] = useState(false);

    const handleClose = () => setShowSideNav(false);
    const handleShow = () => setShowSideNav(true);

    useEffect(() => {
        if (location.pathname !== currentPath) {
            setShowSideNav(false);
            setCurrentPath(location.pathname);
        }
    }, [location.pathname, currentPath]);

    const onOpenChange = (openKeys) => {
        const currentOpenKey = openKeys.find(key => !stateOpenKeys.includes(key));
        if (currentOpenKey !== undefined) {
            const repeatIndex = openKeys
                .filter(key => key !== currentOpenKey)
                .findIndex(key => levelKeys[key] === levelKeys[currentOpenKey]);
            setStateOpenKeys(
                openKeys
                    .filter((_, index) => index !== repeatIndex)
                    .filter(key => levelKeys[key] <= levelKeys[currentOpenKey]),
            );
        } else {
            setStateOpenKeys(openKeys);
        }
    };

    const handleScroll = () => {
        setScrolled(window.scrollY > 100);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <Container fluid className={`header w-100 ${scrolled ? 'header-sticky' : ''} p-0`}>
            <Row className="main-nav-row align-items-center">
                {/* Logo Section */}
                <Col xs={4} md={4} lg={2} className="logo-holder">
                    <Link to='/'>
                        <Image src={scrolled ? logoTwo : logo} style={{ width: '100px' }} />
                    </Link>
                </Col>

                {/* Desktop Nav Items */}
                <Col md={6} lg={7} className="nav-bar-holder d-none d-lg-block">
                    <Nav className="nav-bar justify-content-center">
                        <Link className="link" to='/'>Home</Link>
                        <Link className="link" to='/cpr-park-heights'>Park Heights</Link>
                        <Link className="link" to='/cpr-cosmos'>Cosmos</Link>
                        <Link className="link" to='/cpr-mangala'>Mangala</Link>
                        <Link className="link" to='/privacy-policy'>Privacy</Link>
                        <Link className="link" to='/disclaimer'>Disclaimer</Link>
                    </Nav>
                </Col>

                {/* --- NEW: PHONE NUMBERS (Visible on Desktop) --- */}
                <Col lg={2} className="header-phone-col d-none d-lg-flex justify-content-center border-start border-light px-3">
                    <div className="header-contact-info text-start">
                        <a href="tel:+919908788633" className="header-phone-link link">
                            <FontAwesomeIcon icon={faPhone} /> +91 99087 88633
                        </a>
                    </div>
                </Col>

                {/* Mobile Toggle */}
                <Col xs={8} md={8} lg={1} className="offcanvas-toggle-holder d-flex justify-content-end align-items-center">
                    <Button variant="none" className="menu-icon" onClick={handleShow}>
                        <FontAwesomeIcon icon={faBars} />
                    </Button>
                </Col>
            </Row>

            {/* Mobile Menu Drawer */}
            <Row className="offcanvas">
                <Offcanvas show={showSideNav} onHide={handleClose} placement="end">
                    <Offcanvas.Header closeButton />
                    <Offcanvas.Body>
                        <Menu 
                            mode="inline"
                            openKeys={stateOpenKeys}
                            onOpenChange={onOpenChange}
                            items={mobileMenuItems}
                            style={{ width: '100%', borderRight: 'none' }}
                            onClick={({ key }) => {
                                handleClose();
                                switch (key) {
                                    case 'home': navigate('/'); break;
                                    case 'cpr-park-heights': navigate('/cpr-park-heights'); break;
                                    case 'cpr-cosmos': navigate('/cpr-cosmos'); break;
                                    case 'cpr-mangala': navigate('/cpr-mangala'); break;
                                    case 'privacy-policy': navigate('/privacy-policy'); break;
                                    case 'disclaimer': navigate('/disclaimer'); break;
                                    default: break;
                                }
                            }}
                        />
                    </Offcanvas.Body>
                </Offcanvas>
            </Row>
        </Container>
    );
}

export default Header;